import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import "./Stepper.css";

/*
  Stepper maison (remplace <Steps> antd) : pastilles numérotées reliées par des
  connecteurs, titres masqués sous 768px en CSS (l'ancien stepper lisait
  window.innerWidth au rendu, sans écoute du resize).
  `current` peut dépasser le nombre d'étapes (pages finale et rendez-vous) :
  toutes les étapes passent alors à l'état « fait ».
*/
class Stepper extends PureComponent {
  static propTypes = {
    steps: PropTypes.array.isRequired,
    current: PropTypes.number.isRequired
  };

  render() {
    const { steps, current } = this.props;

    return (
      <div className="stepper">
        {steps.map((step, index) => {
          var stateClass = "stepper-step-todo";
          if (index < current) stateClass = "stepper-step-done";
          else if (index === current) stateClass = "stepper-step-active";

          return (
            <div className={"stepper-step " + stateClass} key={index}>
              {index > 0 && <div className="stepper-connector"></div>}
              <div className="stepper-dot">
                {index < current ? (
                  <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                ) : (
                  index + 1
                )}
              </div>
              <div className="stepper-title">{step.title}</div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default Stepper;
